import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useCustomerData from './useCustomerData';
import resolveAssignedAgentIdFromCustomer from '../../utils/callCustomerAssignment';
import {
  canUserReceiveCalls,
  canUserReceiveIncomingCallForAssignment
} from '../../utils/callsPermissionsUtils';

/**
 * Resolves whether the current user may act on an incoming call (receive + assignment).
 */
export default function useIncomingCallAccessDecision({ callInfoData, updateIncomingPhone }) {
  const currentRetailerUser = useSelector((state) => state.mainReducer?.currentRetailerUser);

  const {
    customer,
    error: customerLookupError,
    isLookupResolved
  } = useCustomerData({
    callInfoData,
    updateIncomingPhone
  });

  const isAuthorizationReady = isLookupResolved && Boolean(currentRetailerUser?.id);
  const assignedAgentId = resolveAssignedAgentIdFromCustomer(customer);

  const canViewIncomingCall = useMemo(() => {
    if (!isAuthorizationReady) return false;

    if (customerLookupError) {
      return canUserReceiveCalls(currentRetailerUser);
    }

    return canUserReceiveIncomingCallForAssignment(
      currentRetailerUser,
      assignedAgentId
    );
  }, [
    isAuthorizationReady,
    currentRetailerUser,
    assignedAgentId,
    customerLookupError
  ]);

  return {
    customer,
    customerLookupError,
    isAuthorizationReady,
    canViewIncomingCall
  };
}
